import type { TableView } from "owa-mail-list-store";
import { useComputedValue } from "owa-react-hooks/lib/useComputed";

export default function useMailListItemFocusState(tableView: Pick<TableView, "focusedRowKey" | "lastAutoFocusedRowKey" | "headerToFocus"> | undefined, tableViewId: string, rowKey: string, isFocusComputedEnabled: boolean): {
    shouldRowBeFocused: boolean;
    shouldRowBeAutoFocused: boolean;
} {
    // Observable dependency reads bypass the computed's per-row change filtering.
    const shouldRowBeFocused = useComputedValue(() => tableView?.focusedRowKey === rowKey && !tableView?.headerToFocus, [
        isFocusComputedEnabled ? tableView : tableViewId,
        rowKey,
        isFocusComputedEnabled ? undefined : tableView?.focusedRowKey,
        isFocusComputedEnabled ? undefined : tableView?.headerToFocus,
    ]);
    const shouldRowBeAutoFocused = useComputedValue(() => tableView?.focusedRowKey === rowKey &&
        tableView?.lastAutoFocusedRowKey !== tableView.focusedRowKey &&
        !tableView?.headerToFocus, [
        isFocusComputedEnabled ? tableView : tableViewId,
        rowKey,
        isFocusComputedEnabled ? undefined : tableView?.focusedRowKey,
        isFocusComputedEnabled ? undefined : tableView?.lastAutoFocusedRowKey,
        isFocusComputedEnabled ? undefined : tableView?.headerToFocus,
    ]);
    
    return { shouldRowBeFocused, shouldRowBeAutoFocused };
}
